import { clearLocalStorage } from './localStorageHelper'

export default function forceLogout(message = 'Your session has expired. Please log in again.') {
    clearLocalStorage()
    window.location.href = `/login?message=${message}`
}